module.exports = __webpack_public_path__ + "img/喷泉.b89ec0d0.png";